import AdminDashboard from "./admin/AdminDashboard";
import ClientDashboard from "./client/ClientDashboard";
import { INTERNAL_USERS } from "core/Constants";
import { useOutletContext } from "react-router-dom";

const Dashboard = () => {
  const { token } = useOutletContext();

  return INTERNAL_USERS.includes(token.type) ? (
    <AdminDashboard />
  ) : (
    <ClientDashboard />
  );
};

export default Dashboard;
